export function defineThemeProp(defaultValue = 'light', additionalOptions = []) {
	return {
		type: String,
		default: defaultValue,
		validator: (value) => ['light', 'dark', ...additionalOptions].includes(value),
	}
}
